module.exports = __webpack_public_path__ + "static/media/border-top.1b2603bd.svg";